<!-- Toolbar -->
<header>
  <mat-toolbar role="banner" color="primary">
    <span class="mat-headline">Google Tasks Manager</span>
    <span class="spacer"></span>
    <app-login (status)="onStatusChange($event)"></app-login>
  </mat-toolbar>
</header>

<main class="content" *ngIf="signedIn">

  <app-tasklists></app-tasklists>

  <section id="tasks-area">
    <section id="lists-area">
      <app-tasks></app-tasks>
      <app-subtasks></app-subtasks>
    </section>
    <app-task-details></app-task-details>
  </section>


</main>

<footer>
  <p>Developed and published by <a href="https://matippetts.github.io">Mark Tippetts</a></p>
</footer>
